import React from 'react'

import './Assets/styles.css'
import { CircularProgress } from '@mui/material'


function HotelSearchCard({ cardRef, search, setSearch, destiny, destinationSelectionFunc, placeholder }) {

    const filterCity = (e) => {
        const seracher = e.target.value
        setSearch(seracher)
    }
    

  return (
    <div className='hotelSearchCard' ref={cardRef}>
        <div className='hotelSearchCard_'>
            <div className='hotelSearchCard_input'>
                <input type="text" onChange={filterCity} required placeholder='Escoje tu destino' />
                {search.length > 2 & destiny.length <= 0 ?
                    <CircularProgress style={{position: 'absolute', right: '60px'}} size={30} />
                    :
                    null
                }
            </div>
            <div className='hotelSearchCard_elements'>
                {destiny.map((element, index) => {
                    return (
                        <div key={index} className='hotelSearchCard_element'>
                            <button onClick={() => destinationSelectionFunc(element)}>
                                {element.name}
                            </button>
                        </div>
                    )
                })}
            </div>
        </div>
    </div>
  )
}

export default HotelSearchCard